import { makeStyles } from '@material-ui/core'

export default makeStyles((theme) => ({
  button: {
    width: (props) => (props.fullWidth ? '100%' : 'auto'),
    background: (props) =>
      props.disabled ? theme.palette.text.disabled : theme.palette.primary.main,
    borderRadius: theme.spacing(0.5),
    color: 'white',
    padding: (props) =>
      props.small ? theme.spacing(0.75, 1) : theme.spacing(2.5, 3.3),
    fontSize: theme.typography.caption.fontSize,
    textTransform: 'capitalize',
    boxShadow: theme.shadows[3],
    [theme.breakpoints.up('md')]: {
      fontSize: theme.typography.body2.fontSize,
    },
    [theme.breakpoints.up('md')]: {
      fontSize: theme.typography.body1.fontSize,
      '&:hover': {
        background: theme.palette.secondary.main,
      },
    },
  },
}))
